import { useMutation } from 'react-query';

import { signup } from '../../lib/api';
import type { Country } from '../../types/user';

export type User = {
  result: string;
  userid: string;
};

export type SignupInput = {
  country: Country;
  password: string;
  email: string;
  firstname: string;
  lastname: string;
  phone: string;
  recaptcha?: string;
  meta_source?: string;
};

export type APIError = {
  result: 'error';
  message: string;
};
export function useMutateSignup() {
  return useMutation(signup);
}
